import MoreVertIcon from "@mui/icons-material/MoreVert";
import NotInterestedIcon from "@mui/icons-material/NotInterested";
import {
    IconButton,
    Menu,
    MenuItem,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Typography
} from "@mui/material";
import axios from "axios";
import * as React from "react";
import { LoadingWrapper } from "../../components/LoadingWrapper";
import { Config } from "../../config/config";
import { Helpers } from "../../utils/helpers";
import { PopupMessage } from "../../utils/message";

interface LeagueRewardsState {
    chests: ChestData[];
    loaded: boolean;
    anchorEl: any;
    menuVisible: boolean;
}

interface LeagueRewardsProps {
    activeUser: any;
    classes: any;

}

export interface ChestData {
    driveKey: string;
    chestName: string;
    description: string;
    chestId: string;
    createdAt: string;
    updatedAt: string;
}

export class LeagueRewards extends React.Component<LeagueRewardsProps, LeagueRewardsState> {

    constructor(props) {
        super(props);
        // List with grid items
        this.state = {
            chests: [],
            loaded: false,
            anchorEl: null,
            menuVisible: false,
        };

        document.title = Helpers.documentTitle("League rewards");
    }

    componentDidMount() {
        this.fetchChests();
    }

    refreshList = () => this.setState({ loaded: false }, () => {
        this.fetchChests();
    })

    openRowMenu = (event) => this.setState({ anchorEl: event.currentTarget }, () => this.setState({ menuVisible: true }));
    closeRowMenu = () => this.setState({ menuVisible: false });
    clearMenuAnchor = () => this.setState({ anchorEl: null });

    fetchChests = async () => {
        try {
            // Put data to S3
            const response = await axios.get(`${Config.getInstance.apiUrl}/api/leagues/rewards`, {
                headers: {
                    Authorization: Helpers.getSessionId(),
                },
            });

            this.setState({ chests: response.data.data, loaded: true });
        } catch (error) {
            this.setState({ loaded: true });

            PopupMessage.error("Couldn't fetch rewards");
        }
    }

    getFileActions = () => {
        if (this.state.anchorEl) {
            const chestId = this.state.anchorEl.getAttribute("chest-key");
            const chestObject = this.state.chests.find(chest => chest.chestId === chestId);

            if (chestObject) {
                 return [
                    <MenuItem onClick={() => this.viewSheets(null, chestObject.driveKey)} key="sheets-chest-key">
                        Google sheet
                    </MenuItem>,
                ];
            }
        }

        return;
    }

    viewSheets = (event, driveKey) => {
        if (!event || event._dispatchListeners.length === 1) {
            const win = window.open(`https://docs.google.com/spreadsheets/d/${driveKey}/edit`, "_blank");
            if (win) {
                win.focus();
            }
        }
    }

    formatChestsToTable = (chests) => {
        if (!chests) {
            return [];
        }

        return chests.map(chest => (
            <TableRow key={chest.chestId} hover={true}>
                <TableCell>{chest.chestId}</TableCell>
                <TableCell>{chest.chestName}</TableCell>
                <TableCell>{chest.description}</TableCell>
                <TableCell style={{ textAlign: "right" }}>
                    <IconButton
                        aria-label="More"
                        aria-haspopup="true"
                        onClick={this.openRowMenu}
                        chest-key={chest.chestId}
                    >
                        <MoreVertIcon />
                    </IconButton>
                </TableCell>
            </TableRow>
        ));
    }

    formatTableBody = (chests) => {
        if (!this.state.loaded) {
            return <div className="no-items-placeholder" style={{ height: 150 }}></div>;
        }

        const { classes } = this.props;

        if (chests && chests.length > 0) {
            return <div>
                <Table style={{  minWidth: 700 }}>
                    <TableHead>
                        <TableRow>
                            <TableCell style={{ width: 20 }}>Id</TableCell>
                            <TableCell style={{ width: 300 }}>Name</TableCell>
                            <TableCell>Description</TableCell>
                            <TableCell style={{ width: 100 }}></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {this.formatChestsToTable(chests)}
                    </TableBody>
                </Table>
                <Menu
                    id="long-menu"
                    anchorEl={this.state.anchorEl}
                    open={this.state.menuVisible}
                    onClose={this.closeRowMenu}
                    onExited={this.clearMenuAnchor}
                >
                    {this.getFileActions()}
                </Menu>
            </div>;
        }

        return <div className="no-items-placeholder">
            <NotInterestedIcon/>
            <h3>No data to display</h3>
        </div>;
    }

    render() {
        const { classes } = this.props;

        return <div className="contentPadding">
            <Paper className="root" elevation={0}>
                <div style={{ float: "left", padding: "15px 22px 15px 22px", width: "100%" }}>
                    <div className={classes.title}>
                        <Typography variant="h6" id="tableTitle">
                            League rewards
                        </Typography>
                    </div>
                </div>

                <div style={{ float: "left", width: "100%" }}>
                    <LoadingWrapper loading={!this.state.loaded}>
                        {this.formatTableBody(this.state.chests)}
                    </LoadingWrapper>
                </div>
            </Paper>
        </div>;
    }
}
